import { render, staticRenderFns } from "./radio-seperated.vue?vue&type=template&id=355b6bb8&scoped=true"
import script from "./radio-seperated.vue?vue&type=script&lang=js"
export * from "./radio-seperated.vue?vue&type=script&lang=js"
import style0 from "./radio-seperated.vue?vue&type=style&index=0&id=355b6bb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355b6bb8",
  null
  
)

export default component.exports